/*jshint esversion: 11*/
/*TODO:
 * In IamPreferences: getAppList()
 *    - nothing is needed and returns production apps
 * in AsExportActions and AsTriggerActions: getAppList(this.jwt.email)
 *    - email is needed
 *    - 703 should be included
 * In CsActions: getAppList(this.jwt.email, this.$store.getters.user.preferences?.apps || [], genericApps || [])
 *    - email, preferredApps and genericApps are needed
 * In CsExports: getAppListWithExportAssociation(this.jwt.email)
 *    - email is needed to return with export association only
 * In CsTriggers: getAppListWithTriggerAssociation(this.jwt.email)
 *    - email is needed to return with trigger association only
 */
/* HISTORY: no-version
 * V250908.1: Made the Sendgrid app (701) available to everyone by setting its onProduction prop from false to true.
 * V250508.1: [on Aref side] In developersAccess(), changed rzamani@mindfireinc.com to rzamani@mindfiremail.info.
 * V250416.1: Added associationType property in getAppList() for app #703 + Removed 'testuser@mindfiremail.info' and 'daver+webinar@mindfireinc.com' from developersAccess().
 * V250411.1: Modified type, typeDesc and componentName properties of app #703.
 * V250407.1: Added 703 app + Changed jshint from 8 to 11 +
      Added getAppList(), getAppListWithExportAssociation() and getAppListWithTriggerAssociation() + 
 * V250324.1: Added Kushal, Ramin and Jason to developersAccess().
 * V250313.1: Added appCode 702 to appList().
 * V250106.1: Added Manasa's email to developersAccess().
 * V240327.1: Added hasExportAssociation, hasTriggerAssociation and onProduction props to the apps.
 * V240126.1: 1st release.
 */

/* TODO: TASKS TO BE DONE:
   - Aref: Handle debug param (?debug=true) in GET /export-actions
   - Aref: Handle debug param (?debug=true) in GET /trigger-actions   
   - Aref: Add debug option to CsTriggers.vue

   + Behzad: Add debug option to CsTriggers.vue
   + Behzad: In CsMenu and exports.vue (Actions tab), make sure that only developers can access.
   + Behzad: Consume this file in Actions.vue and Triggers.vue and Exports (Action tab)

   - App Developer: Staging Lambda functions should pass debug=true query string in order to pick the tasks with debug=true.
*/

function getAppListWithAssociation(prop, email) {
   let appItems = appList().filter(app => app[prop]);
   if (!developersAccess().includes(email))
      appItems = appItems.filter(app => app.onProduction);
   return appItems;
}

// List of users who can see Actions and Triggers menus and the Actions tab in the new export creation.
export function developersAccess() {
   return [
      'rmemarian@mindfiremail.info',
      'btalebpour@mindfireinc.com',
      'mpradeep@mindfireinc.com',
      'kdutta@mindfireinc.com',
      'rzamani@mindfiremail.info',
      'jvoigt@mindfireinc.com'
   ];
}

// List of available apps
export function appList() {
   return [
      {
         text: 'Wallet Pass (700)',
         value: '700',
         type: 'outbound',
         typeDesc: 'Outbound',
         componentName: 'KCWalletPassSelector',
         hasExportAssociation: true, //means export can have association with actions of type of walletpass
         hasTriggerAssociation: false, //means trigger can not have association with actions of type of walletpass
         onProduction: true //every users with the proper policy can see
      },
      {
         text: 'Email - Sendgrid (701)',
         value: '701',
         type: 'outbound',
         typeDesc: 'Outbound',
         componentName: 'BtSendgridEmail',
         hasExportAssociation: true,
         hasTriggerAssociation: true,
         onProduction: true //every users with the proper policy can see
      },
      {
         text: 'Generic App (702)',
         value: '702',
         type: '',            // will be asked 
         typeDesc: '',        // will be filled automatically 
         componentName: '',   // will be asked
         hasExportAssociation: true,
         hasTriggerAssociation: true,
         onProduction: false //just developers with proper policy can see
      },
      {
         text: 'Generic App with UI (703)',
         value: '703',
         type: '',            // will be asked 
         typeDesc: '',        // will be filled automatically 
         componentName: 'BtGenericApp703',   // will be asked
         hasExportAssociation: true,
         hasTriggerAssociation: true,
         onProduction: false //just developers with proper policy can see
      }
   ];
}

export function getAppList(email, preferredApps =null, genericApps =null) {
   // alert(`in getAppList(): email=${email}, preferredApps=${JSON.stringify(preferredApps)}, genericApps=${JSON.stringify(genericApps)}`);
   //path 1: no params
   if (!email) return appList().filter(app => app.onProduction);   //IamPreferences

   //pass 2: email only
   const isDeveloper = developersAccess().includes(email);
   if (preferredApps === null) {
      if (isDeveloper) return appList();
      else return appList().filter(app => app.onProduction);
   }
   
   //pass 3: all params
   let apps = appList().filter(app => app.value != '703');
   // alert('apps1=' + JSON.stringify(apps));
   if (!isDeveloper)
      apps = apps.filter(item => preferredApps.includes(item.value));

   // alert('apps2=' + JSON.stringify(apps));
   if (isDeveloper || preferredApps.includes('703')) {
      // alert('703=' + JSON.stringify(appList().find(item => item.appCode === '703')));
      const app703 = JSON.stringify(appList().find(item => item.value === '703'));
      genericApps.forEach(ga => {
         const app = {
            ...JSON.parse(app703),
            associationType: ga.associationType,
            consumerCode: ga.consumerCode,
            appEndpoint: ga.appEndpoint,
            iframeUrl: ga.iframeUrl
         };
         app.text = ga.name;   // (${ga.appCode})
         app.value = ga.appCode;
         apps.push(app);
      });
      // apps = apps.concat(
      //    genericApps.map(item => ({ text: item.name, value: item.appCode }))
      // );
   }
   // alert('apps3=' + JSON.stringify(apps));

   return apps;
}

export function getAppListWithExportAssociation(email) {
   return getAppListWithAssociation('hasExportAssociation', email);
}

export function getAppListWithTriggerAssociation(email) {
   return getAppListWithAssociation('hasTriggerAssociation', email);
}

// List of the apps events that a trigger can hook to.
export function hookEventList() {
   return [
      { text: 'Wallet Pass: Installed pass', value: '70001' },
      { text: 'Sendgrid: Contact opened Email', value: '70113' },
      { text: 'Sendgrid: Contact clicked a link in Email', value: '70114' },
      { text: 'Sendgrid: Contact opted-out of Email', value: '70115' },
      { text: 'Sendgrid: Contact marked Email as spam', value: '70116' }
   ];
}